import { render, staticRenderFns } from "./bread-crumb.vue?vue&type=template&id=74cd18d2&scoped=true"
import script from "./bread-crumb.vue?vue&type=script&lang=js"
export * from "./bread-crumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cd18d2",
  null
  
)

export default component.exports